import { OrderRelease } from "lib/types/generated/graphql-types"
import { Info } from "./Operations.styled"

type Props = {
  release: OrderRelease | undefined
  status: string
}

const ReleaseInfo = ({ release, status }: Props) => {
  if (status === "RELEASE_PAYMENT_SUCCESS") {
    return (
      <Info>
        <div>{release?.releasedPayment?.reference}</div>
      </Info>
    )
  }
  return null
}

export default ReleaseInfo
